import { useEffect, useState, RefObject } from 'react';

/** px deadzone near each edge within which the scroll shadow stays hidden. */
const SCROLL_SHADOW_THRESHOLD_PX = 10;

interface UseHorizontalScrollIndicatorsReturn {
	showLeftShadow: boolean;
	showRightShadow: boolean;
}

export const useHorizontalScrollIndicators = (ref: RefObject<HTMLDivElement>): UseHorizontalScrollIndicatorsReturn => {
	const [showLeftShadow, setShowLeftShadow] = useState(false);
	const [showRightShadow, setShowRightShadow] = useState(false);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const handleScroll = () => {
			const { scrollLeft, scrollWidth, clientWidth } = element;

			// Show left shadow if scrolled from the start
			setShowLeftShadow(scrollLeft > SCROLL_SHADOW_THRESHOLD_PX);

			// Show right shadow if not scrolled to the end
			setShowRightShadow(scrollLeft < scrollWidth - clientWidth - SCROLL_SHADOW_THRESHOLD_PX);
		};

		// Initial check
		handleScroll();

		// Add event listeners
		element.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', handleScroll);

		// Cleanup
		return () => {
			element.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleScroll);
		};
	}, [ref]);

	return { showLeftShadow, showRightShadow };
};
